export const DEFAULT_BUFFER_DAYS = 4;